import { teamData } from "./data";
import TeamCard from "./TeamCard";

const TeamCards = () => {
  return (
    <section
      id="team"
      className="md:mt-[137px] mt-[127px] pt-[100px] pb-[213px] bg-white"
    >
      <div className="mx-auto xl:max-w-[1424px] xl:px-0 container space-y-10 md:space-y-[56px] lg:space-y-[96px]">
        <div className=" space-y-1 ">
          <h4 className="font-bold  text-light text-xs text-center ">
            Our Team
          </h4>
          <div className="space-y-4">
            <h1 className="  feat-head-m md:feat-head-t xl:feat-head-d ">
              Talented and{" "}
              <span className="text-[#433CAE] block sm:inline-block">
                Experienced Team
              </span>
            </h1>
            <p className="!text-[#6D6D6D] max-w-[1020px] mx-auto  text-center  lg:text-[21px] text-lg   font-medium     ">
            Meet Our Team of Specialists
            </p>
          </div>
        </div>
        <div className=" grid gap-4 lg:grid-cols-3 md:grid-cols-2 grid-cols-1">
          {teamData.map((team, key) => (
            <TeamCard {...team} key={team.name + key} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamCards;
